

var _squid = require('squid');

define(['squid/index'], function (squid) {

    (function exportProviders(angular) {
        angular && angular.exportProviders(module, exports, __dirname, __filename);
    })(window.angular);

    squid.module('xomodel.app', ['squid']).factory('$TransactionEligibilityModel', function ($Model, $Api) {
        return $Model.extend('TransactionEligibilityModel', {
            api: new $Api({
                uri: '/api/eligibility/transaction/:id'
            })
        });
    }).factory('$BuyerEligibilityModel', function ($Model, $Api) {
        return $Model.extend('BuyerEligibilityModel', {
            api: new $Api({
                uri: '/api/eligibility/buyer/:id'
            }),

            invalidateOnLogout: true // invalidate this model when auth.logout() gets called
        });
    }).factory('$PXPModel', function ($Model, $Api) {
        return $Model.extend({
            api: new $Api({
                uri: '/api/pxp/:id'
            })
        });
    }).factory('$LocaleConfigModel', function ($Model, $Api) {
        return $Model.extend({
            api: new $Api({
                uri: '/api/localeConfig'
            })
        });
    }).factory('$AppDataModel', function ($Model, $Api) {
        return $Model.extend('AppDataModel', {
            api: new $Api({
                uri: '/api/app'
            }),

            isMobile: function isMobile() {
                return this.platform === 'mobile';
            }
        });
    }).factory('$MessengerIntegrationDataModel', function ($Model, $Api) {
        return $Model.extend('MessengerIntegrationDataModel', {
            api: new $Api({
                uri: '/api/messenger'
            })
        });
    }).factory('$TokenizedWalletEligibilityModel', function ($Model, $Api) {
        return $Model.extend('TokenizedWalletEligibilityModel', {
            api: new $Api({
                uri: '/api/eligibility/tokenizedWallet/:id'
            }),

            invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

            isEligible: function isEligible() {
                return this.eligible;
            }
        });
    }).factory('$TokenizedWalletInfoModel', function ($Model, $Api) {
        var _brandNames, _msbDisclaimerLinks;

        var subjectTypes = {
            SAMSUNG_PAY: 'Samsung',
            ANDROID_PAY: 'google'
        };

        var brandNames = (_brandNames = {}, _brandNames[subjectTypes.SAMSUNG_PAY] = 'Samsung Pay', _brandNames[subjectTypes.ANDROID_PAY] = 'Google Pay', _brandNames);

        // disclaimer links used on the *pay review page
        var disclaimerLinks = function disclaimerLinks(country) {
            var _ref;

            return _ref = {}, _ref[subjectTypes.SAMSUNG_PAY] = 'https://www.paypal.com/' + country + '/webapps/mpp/ua/ppsamsungpay-tnc', _ref[subjectTypes.ANDROID_PAY] = 'https://www.paypal.com/' + country + '/webapps/mpp/ua/ppandroidpay-tnc', _ref;
        };

        // disclaimer links used on Msb offer popup
        var msbDisclaimerLinks = (_msbDisclaimerLinks = {}, _msbDisclaimerLinks[subjectTypes.SAMSUNG_PAY] = 'https://www.paypal.com/us/smarthelp/article/samsung-pay-terms-and-conditions-faq3863', _msbDisclaimerLinks[subjectTypes.ANDROID_PAY] = 'https://www.paypal.com/us/smarthelp/article/google-pay-terms-and-conditions-faq3862', _msbDisclaimerLinks);

        /**
         * this model populates data from tokenized wallet mayfly object
         * (see xo-hermes-app/apis/tokenizedWalletInfo) which contains:
         *
         * - wallet_id (used for both Samsung Pay and Android Pay)
         * - external_device_id (used for Samsung Pay only)
         * - subject (used for both Samsung Pay and Android Pay)
         *
         * Note: model is being populated in xo-preload on the server (see config.json)
         */
        return $Model.extend('TokenizedWalletInfoModel', {

            api: new $Api({
                uri: '/api/info/tokenizedWallet/:id'
            }),

            isAndroidPay: function isAndroidPay() {
                return this.subject === subjectTypes.ANDROID_PAY;
            },

            isSamsungPay: function isSamsungPay() {
                return this.subject === subjectTypes.SAMSUNG_PAY;
            },

            getSubject: function getSubject() {
                return this.subject || subjectTypes.ANDROID_PAY;
            },

            // until we use mayfly for android pay - fallback to Android Pay
            brandName: function brandName() {
                return brandNames[this.subject] || brandNames[subjectTypes.ANDROID_PAY];
            },

            // until we use mayfly for android pay - fallback to Android Pay
            getDisclaimerLink: function getDisclaimerLink() {
                var country = _squid.$locale.country.toLowerCase();
                return disclaimerLinks(country)[this.subject] || disclaimerLinks(country)[subjectTypes.ANDROID_PAY];
            },

            // get Msb terms and conditions link based on the subject
            getMsbDisclaimerLink: function getMsbDisclaimerLink() {
                return msbDisclaimerLinks[this.subject] || msbDisclaimerLinks[subjectTypes.ANDROID_PAY];
            }
        });
    }).factory('$TokenizedFundingCapabilitiesModel', function ($Model, $Api) {

        return $Model.extend('TokenizedFundingCapabilitiesModel', {

            api: new $Api({
                uri: '/api/capabilities/tokenizedWallet/:id'
            }),
            invalidateOnLogout: true,

            isDirectFundingEnabled: function isDirectFundingEnabled() {
                return this.directFundingEnabled;
            },

            isTopupEnabled: function isTopupEnabled() {
                return this.topupFundingEnabled;
            },
            getProductName: function getProductName() {
                return this.name;
            },

            getCurrency: function getCurrency() {
                return this.issuingCurrency;
            },

            getContingencies: function getContingencies() {
                return this.contingencies;
            },

            getTopupAmountChoices: function getTopupAmountChoices() {
                return this.topUpAmountChoices;
            }
        });
    }).factory('$TokenizedWalletPinModel', function ($Model, $Api) {
        return $Model.extend('TokenizedWalletPinModel', {
            api: new $Api({
                uri: '/api/pin/tokenizedWallet/:id'
            }),

            invalidateOnLogout: true, // invalidate this model when auth.logout() gets called

            getPinOrigin: function getPinOrigin() {
                return this.pinOrigin;
            },
            getSuggestedPin: function getSuggestedPin() {
                return this.suggestedPin;
            },
            getSuggestedKey: function getSuggestedKey() {
                return this.suggestedKey;
            },
            getPinId: function getPinId() {
                return this.pinId;
            },
            isPinIdPresent: function isPinIdPresent() {
                return !!this.pinId;
            },
            isSetupEligible: function isSetupEligible() {
                return this.pinOrigin === 'UNSET' || this.pinOrigin === 'SYSTEM';
            }
        });
    }).factory('$TokenizedWalletMsbOfferModel', function ($Model, $Api) {
        return $Model.extend('TokenizedWalletMsbOfferModel', {
            api: new $Api({
                uri: '/api/msb/tokenizedWallet/:id'
            }),
            invalidateOnLogout: true
        });
    }).factory('$PXPBlacklist', function () {
        return {
            isMerchantBlacklisted: function isMerchantBlacklisted(merchantId) {
                return _squid.$config.pxpBlacklist && _squid.$config.pxpBlacklist.merchant && _squid.$config.pxpBlacklist.merchant.indexOf(merchantId) !== -1;
            }
        };
    });
});

_squid.$config;

_squid.$locale;


//////////////////
// WEBPACK FOOTER
// ./components/xo-models/src/app/index.js
// module id = ./components/xo-models/src/app/index.js
// module chunks = 1